import React from 'react';
import Icon from '@mdi/react';
import styled from 'styled-components';

export interface TableTitleProps {
  icon: string;
  title: string;
}

const TitleContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const TitleIcon = styled(Icon)`
  color: ${(props) => props.theme.foreground};
`;

const Title = styled.p`
  margin-left: 5px;
`;

export const TableTitle = ({ icon, title }: TableTitleProps) => (
  <TitleContainer>
    <TitleIcon path={icon} size={1} />
    <Title>{title}</Title>
  </TitleContainer>
);
